import { initGravityGateway } from '@/modules/gateway';

/**
 * @ngInject
 */
export default function (GravityGatewayService) {
  GravityGatewayService.init();
  initGravityGateway();
}
